(function() {
	var NumbersOnly = (function() {
		var __private = {
			listener(el) {
				if(el instanceof HTMLElement) {
					el.addEventListener("keypress", function(event) {
						event = event || window.event;
						var key = event.key;
						var code = event.keyCode;

						if(!isMobile.iOS()) {
							if(isNaN(key) && key !== "/" && key !== "\\" && key !== " " && code !== 8 && code !== 37 && code !== 39 && code !== 46)
								event.preventDefault();
						} else
							if((code < 48 || code > 57) && code !== 13)
								event.preventDefault();
						
					});
				}
			}
		};

		return {
			init(el) {
				__private.listener(el);
			}
		};
	})();

	document.addEventListener("DOMContentLoaded", function() {
		var selector = "input[type='number']";
		var numbers  = document.querySelectorAll(selector);

		if(numbers.length > 0) {
			for (let i = 0; i < numbers.length; i++) {
				NumbersOnly.init(numbers[i]);
			}
		}
	});
})();